import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type {
  AdminPaymentlineView,
  AdminPaymentlinesPage,
  AdminPaymentlinesQuery,
  PaymentlineAuditView,
  PaymentlineStatus,
  PaymentMethod,
} from 'shared-models/browser';

export type { AdminPaymentlineView, AdminPaymentlinesPage, AdminPaymentlinesQuery, PaymentlineAuditView } from 'shared-models/browser';

export type UpdateAdminPaymentlinePayload = {
  status: PaymentlineStatus;
  method: PaymentMethod;
  amount: number;
};

class AdminPaymentsService {
  async list(query: AdminPaymentlinesQuery = {}): Promise<AdminPaymentlinesPage> {
    try {
      const response = await authenticatedInstance.get<AdminPaymentlinesPage>('/payments/admin/lines', {
        params: query,
        paramsSerializer: {
          indexes: null,
        },
      });
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, ''));
    }
  }

  async update(paymentlineId: number, payload: UpdateAdminPaymentlinePayload): Promise<AdminPaymentlineView> {
    try {
      const response = await authenticatedInstance.patch<AdminPaymentlineView>(`/payments/admin/lines/${paymentlineId}`, payload);
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, ''));
    }
  }

  async listAudit(paymentlineId: number): Promise<PaymentlineAuditView[]> {
    try {
      const response = await authenticatedInstance.get<PaymentlineAuditView[]>(`/payments/admin/lines/${paymentlineId}/audit`);
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, ''));
    }
  }
}

export const adminPaymentsService = new AdminPaymentsService();
